export class AppConstants {
    public static get API_URL():string { return "https://web-production-2ca20.up.railway.app"; };
}
export enum Roles {
    OWNER ="ROLE_OWNER",
    ADMIN ="ROLE_ADMIN",
    MODERATOR ="ROLE_MODERATOR",
    BASIC ="ROLE_BASIC",
    PREMIUM ="ROLE_PREMIUM",
    GOLD ="ROLE_GOLD",
    PLATINUM ="ROLE_PLATINUM"
}